"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["sentiment", "children"];
var SENTIMENT = {
  NEGATIVE: 'neg',
  NEUTRAL: 'neu',
  POSITIVE: 'pos'
};

var HotelTrustYouGoodToKnowItem = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var sentiment = _ref.sentiment,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", props, /*#__PURE__*/_react["default"].createElement(StyledCircle, {
    sentiment: sentiment
  }), children);
});

HotelTrustYouGoodToKnowItem.propTypes = {
  className: _propTypes["default"].string,
  sentiment: _propTypes["default"].oneOf(Object.keys(SENTIMENT).map(function (item) {
    return SENTIMENT[item];
  })).isRequired,
  children: _propTypes["default"].node.isRequired
};
HotelTrustYouGoodToKnowItem.defaultProps = {
  className: ''
};

var StyledCircle = _styledComponents["default"].span.withConfig({
  displayName: "HotelTrustYouGoodToKnowItem__StyledCircle",
  componentId: "sc-1yrgmz0-0"
})(["width:9px;height:9px;display:inline-block;border-radius:100%;margin-right:10px;background:", ""], function (_ref2) {
  var sentiment = _ref2.sentiment,
      theme = _ref2.theme;
  var color = theme.colors.blackLight;

  if (sentiment === SENTIMENT.POSITIVE) {
    color = '#0cb7b0';
  } else if (sentiment === SENTIMENT.NEUTRAL) {
    color = '#28bd61';
  }

  return color;
});

HotelTrustYouGoodToKnowItem.Circle = StyledCircle;
HotelTrustYouGoodToKnowItem.SENTIMENT = SENTIMENT;
var _default = HotelTrustYouGoodToKnowItem;
exports["default"] = _default;